import { Box, Grid, Slider } from '@mui/material';
import { format } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';

const SingleDateSlider = ({ minDate, maxDate, defaultDate, setDefaultDate }) => {
    const startDate = useMemo(() => new Date(minDate.replace(/-/g, '/').replace(/T.+/, '')), [minDate]);
    const endDate = useMemo(() => new Date(maxDate.replace(/-/g, '/').replace(/T.+/, '')), [maxDate]);
    const initialDate = useMemo(() => new Date(defaultDate.replace(/-/g, '/').replace(/T.+/, '')), [defaultDate]);

    const initialSliderValue = useMemo(() => (initialDate - startDate) / (1000 * 3600 * 24), [initialDate, startDate]);
    const totalDays = useMemo(() => (endDate - startDate) / (1000 * 3600 * 24), [endDate, startDate]);

    const [sliderValue, setSliderValue] = useState(initialSliderValue);

    useEffect(() => {
        const newDate = new Date(defaultDate.replace(/-/g, '/').replace(/T.+/, ''));
        const newSliderValue = (newDate - startDate) / (1000 * 3600 * 24);
        setSliderValue(newSliderValue);
    }, [defaultDate, startDate]);

    const handleSliderChange = (event, newValue) => {
        const selectedDate = valueToDate(newValue);
        setDefaultDate(selectedDate.toISOString());
    };

    const valueToDate = (value) => {
        const selectedDate = new Date(startDate);
        selectedDate.setDate(startDate.getDate() + value);
        return selectedDate;
    };

    const formatTooltipValue = (value) => {
        const selectedDate = valueToDate(value);
        return format(selectedDate, 'dd/MM/yyyy');
    };

    return (
        <Box sx={{ width: '100%', margin: 'auto', p: { xs: 1, md: 4 } }}>
            <Grid container direction='column'>
                <Grid item>
                    <Slider
                        value={sliderValue}
                        onChangeCommitted={handleSliderChange}
                        onChange={(_, newValue) => setSliderValue(newValue as number)}
                        valueLabelDisplay='on'
                        valueLabelFormat={formatTooltipValue}
                        aria-labelledby='single-date-slider'
                        min={0}
                        max={totalDays}
                    />
                </Grid>
                <Grid item container justifyContent='space-between'>
                    <Grid item>{format(startDate, 'dd/MM/yyyy')}</Grid>
                    <Grid item>{format(endDate, 'dd/MM/yyyy')}</Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SingleDateSlider;
